import React from 'react'
import styled from 'styled-components'
import ListGroup from 'react-bootstrap/cjs/ListGroup'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { _ } from '../../../../utils/localization'
import Icon from '../../../../components/Icon'
import { Booth } from '../../types'

const S = {
    Header: styled.div`
        padding: 20px;
        background: transparent;
        font-size: 22px;
        font-weight: 500;
    `,
    DocumentItem: styled(ListGroup.Item)`
        display: flex;
        align-items: center;
        &.active {
            background-color: inherit;
            border-color: inherit;
            color: inherit;
        }
    `
}

const BoothDocuments = ({ boothDetail }: {boothDetail: Booth}) => {
    const { trackEvent } = useMatomo()
    const trackAction = (action, name) => {
        trackEvent({
            category: boothDetail.name,
            action,
            name,
        })
    }

    return (
        <div>
            <S.Header>
                {_('booth.tabs.documents')}
            </S.Header>
            <ListGroup style={{ borderRadius: 0 }}>
                {boothDetail.documents.map((document) => (
                    <S.DocumentItem
                        action
                        href={document.url}
                        target="_blank"
                        key={document.id}
                        rel="noopener noreferrer"
                        onClick={() => trackAction('file downloaded', document.name)}
                    >
                        <Icon icon="file" style={{ margin: '0 20px 3px 0' }} />
                        {document.name}
                    </S.DocumentItem>
                ))}
            </ListGroup>
        </div>
    )
}

export default BoothDocuments
